module.exports = __webpack_public_path__ + "img/shop-by-coupe.f730e1bb.png";